var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeCaixaPersonalizada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4029_9570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2947 74.5985L1.26958 58.6492C0.494824 58.286 0 57.5075 0 56.6518V20.8175L35.2947 37.1073V74.5985ZM75 20.8178V56.6518C75 57.5074 74.5052 58.286 73.7304 58.6491L39.7065 74.5979V37.1071L75 20.8178ZM52.7745 43.0356L63.8039 37.8656C64.9069 37.3485 65.382 36.0351 64.865 34.932C64.3481 33.8288 63.0346 33.3539 61.9314 33.8708L50.902 39.0408C49.799 39.5579 49.3239 40.8713 49.8409 41.9745C50.3578 43.0777 51.6713 43.5527 52.7745 43.0356ZM1.92539 16.8471L36.5637 0.610376C37.1569 0.332349 37.8429 0.332349 38.4362 0.610376L73.0749 16.8473L37.5003 33.2663L1.92539 16.8471Z",
    fill: "#2544B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4029_9570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCaixaPersonalizada);
export default __webpack_public_path__ + "static/media/icone-caixa-personalizada.7eb01e5b3cb5a27b8e85dd80a71ec368.svg";
export { ForwardRef as ReactComponent };